import React, { useState, useEffect } from 'react';

let showToastFunction = null;

export const showToast = (message, type = 'info', duration = 3000) => {
  if (showToastFunction) {
    showToastFunction(message, type, duration);
  }
};

const Toast = () => {
  const [toasts, setToasts] = useState([]);

  useEffect(() => {
    showToastFunction = (message, type, duration) => {
      const id = Date.now();
      const toast = { id, message, type, duration };
      
      setToasts(prev => [...prev, toast]);
      
      setTimeout(() => {
        setToasts(prev => prev.filter(t => t.id !== id));
      }, duration);
    };
    
    return () => {
      showToastFunction = null;
    };
  }, []);

  const getToastStyles = (type) => {
    switch (type) {
      case 'success':
        return 'bg-lime-50 text-white';
      case 'error':
        return 'bg-red-50 text-white';
      case 'warning':
        return 'bg-yellow-50 text-gray';
      default:
        return 'bg-gray-50 text-white';
    }
  };

  return (
    <div className="fixed top-4 right-4 z-50 space-y-2">
      {toasts.map((toast) => (
        <div
          key={toast.id}
          className={`px-6 py-3 rounded-lg shadow-lg transform transition-all duration-300 animate-slide-up ${getToastStyles(toast.type)}`}
        >
          <p className="font-medium">{toast.message}</p>
        </div>
      ))}
    </div>
  );
};

export default Toast;